/**
 * External dependencies
 */
import { Reducer } from 'redux';
import produce from 'immer';

/**
 * Internal dependencies
 */
import Contact from '@naruto/bgdcms/src/reducers/stores/contact';
import CONTACT_ACTION from '@naruto/bgdcms/src/reducers/cores/contact/events';
import { CreateContactReducerParams, ContactActionTypes } from './types';

export function createContactReducer(params: CreateContactReducerParams): Reducer<Contact, ContactActionTypes> {
  return (state = params.initialState, action: ContactActionTypes): Contact =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case CONTACT_ACTION.SET_CONTACT_INITIALIZE:
          draft.initialize();
          break;
        case CONTACT_ACTION.SET_CONTACT_INFO:
          draft.updateContactInfo(action.contactInfo);
          break;
        default:
          break;
      }
    });
}
